
(function() {
  var VARIANT_ID = window.KLM_VARIANT_ID;
  var selectedQty = 1;

  /* Gallery */
  var thumbs = document.querySelectorAll('#klmGalleryThumbs img');
  var mainImg = document.getElementById('klmGalleryMain');
  thumbs.forEach(function(t) {
    t.addEventListener('click', function() {
      thumbs.forEach(function(x) { x.classList.remove('active'); });
      t.classList.add('active');
      mainImg.src = t.getAttribute('data-src');
    });
  });

  /* Pricing */
  window.klmSelectQty = function(qty) {
    selectedQty = qty;
    document.querySelectorAll('.klm-price-option').forEach(function(o) {
      o.classList.toggle('active', parseInt(o.getAttribute('data-qty')) === qty);
    });
    var sel = document.querySelector('.klm-price-option[data-qty="' + qty + '"]');
    if (sel) {
      var total = sel.getAttribute('data-total');
      var old = sel.getAttribute('data-old');
      var perKit = sel.getAttribute('data-per-kit') || total;
      var fmt = function(v){ return '€' + String(v).replace('.', ','); };
      document.getElementById('klmBtnPrice').textContent = fmt(total);
      var stPrice = document.getElementById('klmStickyPrice'); if (stPrice) stPrice.textContent = fmt(total);
      var stOld = document.getElementById('klmStickyOld'); if (stOld) stOld.textContent = fmt(old);
      var stQty = document.getElementById('klmStickyQty'); if (stQty) stQty.textContent = qty + ' Kit';
      var stPerKit = document.getElementById('klmStickyPerKit'); if (stPerKit) stPerKit.textContent = fmt(perKit);
      // Hide redundant info when only 1 kit (per-kit == total)
      var totalLabel = document.getElementById('klmStickyTotalLabel');
      if (totalLabel) {
        var isSingle = parseInt(qty, 10) === 1;
        totalLabel.style.display = isSingle ? 'none' : '';
        if (stPrice) stPrice.style.display = isSingle ? 'none' : '';
        var sep = totalLabel.previousElementSibling;
        if (sep && sep.tagName === 'SPAN') sep.style.display = isSingle ? 'none' : '';
      }
    }
  };
  window.klmStickyQtyChange = function(delta) {
    var current = parseInt(document.querySelector('.klm-price-option.active')?.getAttribute('data-qty') || '1', 10);
    var next = Math.max(1, Math.min(3, current + delta));
    if (next !== current) window.klmSelectQty(next);
  };

  (function(){
    var origSelect = window.klmSelectQty;
    window.klmSelectQty = function(qty){
      origSelect.apply(this, arguments);
      var stNum = document.getElementById('klmStickyQtyNum');
      if (stNum) stNum.textContent = String(qty);
    };
  })();

  try { window.klmSelectQty(1); } catch (e) {}

  /* Reset CTA */
  function klmCtaDefaultHtml() {
    var btnPrice = '€64,90';
    try {
      var sel = document.querySelector('.klm-price-option.active');
      if (sel) {
        var total = sel.getAttribute('data-total');
        if (total) btnPrice = '€' + total.replace('.', ',');
      }
    } catch (e) {}
    return '<span style="white-space:nowrap !important">Aggiungi al carrello</span> <span style="opacity:.5 !important">·</span> <span id="klmBtnPrice" style="white-space:nowrap !important">' + btnPrice + '</span>';
  }
  function klmResetCta() {
    var btn = document.getElementById('klmAddBtn');
    if (!btn) return;
    btn.innerHTML = klmCtaDefaultHtml();
    btn.disabled = false;
  }
  window.addEventListener('pageshow', klmResetCta);
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible') klmResetCta();
  });

  /* Add to cart — opens theme's sliding cart drawer (no redirect) */
  window.klmAddToCart = function() {
    var btn = document.getElementById('klmAddBtn');
    if (btn.disabled) return;
    btn.innerHTML = 'Aggiungo...';
    btn.disabled = true;

    var cartDrawer = document.querySelector('cart-drawer');
    var sectionsString = null;
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      try {
        sectionsString = cartDrawer.getSectionsToRender().map(function(s){ return s.section; }).join(',');
      } catch (e) {}
    }

    var formData = new FormData();
    formData.append('id', String(VARIANT_ID));
    formData.append('quantity', String(selectedQty));
    if (sectionsString) {
      formData.append('sections', sectionsString);
      formData.append('sections_url', window.location.pathname);
    }

    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function(r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(parsedState) {
        if (parsedState && parsedState.status && parsedState.status >= 400) {
          klmResetCta();
          alert(parsedState.description || 'Impossibile aggiungere al carrello.');
          return;
        }

        btn.innerHTML = '✓ Aggiunto';

        try {
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'klm-pdp', productVariantId: VARIANT_ID, cartData: parsedState });
          }
        } catch (e) { console.warn('publish failed', e); }

        try {
          var opened = false;
          if (cartDrawer && typeof cartDrawer.renderContents === 'function' && parsedState && parsedState.sections) {
            try { cartDrawer.renderContents(parsedState); opened = true; }
            catch (e) { console.warn('renderContents failed', e); }
          }
          if (!opened && cartDrawer) {
            try { if (typeof cartDrawer.reload === 'function') cartDrawer.reload(); } catch (e) {}
            setTimeout(function() {
              try {
                if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
                else document.dispatchEvent(new CustomEvent('cart:open'));
              } catch (e) { console.warn('open failed', e); }
            }, 80);
          } else if (!cartDrawer) {
            document.dispatchEvent(new CustomEvent('cart:open'));
          }
        } catch (e) { console.warn('drawer open chain failed', e); }

        setTimeout(klmResetCta, 1500);
      })
      .catch(function(err) {
        console.error('klmAddToCart fetch error', err);
        klmResetCta();
        alert('Errore di rete. Riprova.');
      });
  };

  /* Sticky */
  var stickyAtc = document.getElementById('klmStickyAtc');
  var heroPdp = document.querySelector('.klm-hero-pdp');
  var footerCta = document.querySelector('.klm-footer-cta');
  function checkSticky() {
    if (!heroPdp || !stickyAtc) return;
    var heroBottom = heroPdp.getBoundingClientRect().bottom;
    var footerTop = footerCta ? footerCta.getBoundingClientRect().top : 99999;
    stickyAtc.classList.toggle('visible', heroBottom < 0 && footerTop > window.innerHeight - 80);
  }
  window.addEventListener('scroll', checkSticky, { passive: true });
  window.addEventListener('resize', checkSticky);
  setTimeout(checkSticky, 100);

  /* Scroll fade-in animations */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.klm-fade').forEach(function(el) { io.observe(el); });
  } else {
    document.querySelectorAll('.klm-fade').forEach(function(el) { el.classList.add('in'); });
  }

  /* QUIZ */
  var quizScore = 0, quizStep = 1, quizTotal = 4;
  window.klmQuizAns = function(btn) {
    quizScore += parseInt(btn.getAttribute('data-score')) || 0;
    var current = document.querySelector('.klm-quiz-step[data-step="' + quizStep + '"]');
    if (current) current.classList.remove('active');
    quizStep++;
    if (quizStep <= quizTotal) {
      var next = document.querySelector('.klm-quiz-step[data-step="' + quizStep + '"]');
      if (next) next.classList.add('active');
      var fill = document.getElementById('klmQuizFill');
      if (fill) fill.style.width = (quizStep * 25) + '%';
    } else {
      var resultStep = document.querySelector('.klm-quiz-step[data-step="result"]');
      if (resultStep) resultStep.classList.add('active');
      var fill = document.getElementById('klmQuizFill');
      if (fill) fill.style.width = '100%';
      klmQuizShowResult(quizScore);
    }
  };
  function klmQuizShowResult(score) {
    var emoji = document.getElementById('klmQuizEmoji');
    var title = document.getElementById('klmQuizResultTitle');
    var text = document.getElementById('klmQuizResultText');
    if (score >= 6) {
      emoji.innerHTML = '&#127919;';
      title.textContent = 'Sì, è il kit per te.';
      text.innerHTML = 'I tuoi segnali (vampate, sonno disturbato, sbalzi d\'umore, stanchezza) puntano tutti nella stessa direzione: <strong>il cambio ormonale sta sostenendo un carico importante.</strong> Il kit è disegnato per questo profilo. Inizia un ciclo di 8 settimane.';
    } else if (score >= 3) {
      emoji.innerHTML = '&#128064;';
      title.textContent = 'Vale la pena provare.';
      text.innerHTML = 'Alcuni segnali ci sono già. Un ciclo di 8 settimane è la finestra ideale per <strong>capire se il tuo corpo risponde</strong>. Niente promesse miracolose, solo claim approvati EFSA e Ministero della Salute.';
    } else {
      emoji.innerHTML = '&#128170;';
      title.textContent = 'Sembri in buon equilibrio.';
      text.innerHTML = 'I segnali sono pochi. Se vuoi un supporto preventivo nelle fasi di transizione, il kit funziona anche come <strong>protocollo a fasi</strong>. Altrimenti, conserva la pagina per quando ne avrai bisogno.';
    }
  }

  /* CAROUSELS */
  window.klmCarouselScroll = function(trackId, dir) {
    var track = document.getElementById(trackId);
    if (!track) return;
    var card = track.querySelector('.klm-mech-card, .klm-efsa-card, .klm-bot-card');
    var step = card ? card.offsetWidth + parseInt(getComputedStyle(track).gap || 18) : 320;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  };

  function setupCarousel(trackId, dotsId) {
    var track = document.getElementById(trackId);
    var dotsEl = document.getElementById(dotsId);
    if (!track || !dotsEl) return;
    var cards = track.children.length;
    dotsEl.innerHTML = '';
    for (var i = 0; i < cards; i++) {
      (function(idx) {
        var d = document.createElement('button');
        d.className = 'klm-carousel-dot' + (idx === 0 ? ' active' : '');
        d.setAttribute('aria-label', 'Card ' + (idx + 1));
        d.onclick = function() {
          var card = track.children[idx];
          if (card) track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        };
        dotsEl.appendChild(d);
      })(i);
    }
    function updateDots() {
      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var bestIdx = 0, bestDist = Infinity;
      for (var i = 0; i < track.children.length; i++) {
        var r = track.children[i].getBoundingClientRect();
        var c = r.left + r.width / 2;
        var dist = Math.abs(c - center);
        if (dist < bestDist) { bestDist = dist; bestIdx = i; }
      }
      Array.from(dotsEl.children).forEach(function(d, i) {
        d.classList.toggle('active', i === bestIdx);
      });
    }
    track.addEventListener('scroll', updateDots, { passive: true });
    setTimeout(updateDots, 50);

    var isDown = false, startX, scrollLeft;
    track.addEventListener('mousedown', function(e) {
      isDown = true; startX = e.pageX - track.offsetLeft; scrollLeft = track.scrollLeft;
    });
    track.addEventListener('mouseleave', function() { isDown = false; });
    track.addEventListener('mouseup', function() { isDown = false; });
    track.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      track.scrollLeft = scrollLeft - (x - startX);
    });
  }
  setupCarousel('klmMechTrack', 'klmMechDots');
  setupCarousel('klmEfsaTrack', 'klmEfsaDots');

  /* CORTISOL (now: equilibrio ormonale) STAGGER ANIMATION */
  if ('IntersectionObserver' in window) {
    var ioCort = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          ioCort.unobserve(e.target);
        }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('.klm-cortisol-step').forEach(function(el) { ioCort.observe(el); });
  }

  /* QUALITY STAGGER */
  if ('IntersectionObserver' in window) {
    var ioQ = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          ioQ.unobserve(e.target);
        }
      });
    }, { threshold: 0.3 });
    document.querySelectorAll('.klm-quality-card').forEach(function(el) { ioQ.observe(el); });
  }

  /* REVIEWS — focus menopausa */
  var FALLBACK = [
    { s: 5, t: "Le vampate notturne erano la mia croce. Dopo 5 settimane di Lady + MAG-5 la sera mi sveglio molto meno sudata. Sto continuando per un altro ciclo.", n: "Patrizia D.", i: "PD", tags: ["vampate", "sonno"] },
    { s: 5, t: "Ho 52 anni e i sintomi iniziavano a darmi fastidio. Il kit è facile da seguire: una compressa al mattino, un misurino la sera. Buona spedizione.", n: "Giuliana M.", i: "GM", tags: ["vampate"] },
    { s: 5, t: "Da quando prendo il magnesio bisglicinato la sera, addormentarmi è diventato semplice. Mai più magnesio in capsule per me.", n: "Marta P.", i: "MP", tags: ["sonno"] },
    { s: 4, t: "Le vampate non sono sparite, ma sono molto più gestibili. L'umore è la cosa che è cambiata di più, mi sento meno reattiva.", n: "Sara L.", i: "SL", tags: ["vampate", "umore"] },
    { s: 5, t: "Confronto con altri integratori menopausa: qui il Trifoglio Rosso è dosato seriamente, 80 mg di isoflavoni reali. Trasparenza che apprezzo.", n: "Federica T.", i: "FT", tags: ["vampate"] },
    { s: 5, t: "L'irritabilità con marito e figli era diventata un problema. Dopo 6 settimane mi sento molto più equilibrata, gestisco meglio le situazioni.", n: "Anna R.", i: "AR", tags: ["umore"] },
    { s: 5, t: "Lo prendo da 4 settimane. La mattina mi sveglio meno pesante, le ossa non mi 'scrocchiano' più come prima. Spedizione veloce.", n: "Chiara V.", i: "CV", tags: ["ossa", "energia"] },
    { s: 4, t: "Buona idea il kit, comodo avere tutto incluso. Il magnesio in polvere sa di limone, è piacevole prima di letto.", n: "Elena B.", i: "EB", tags: ["sonno"] },
    { s: 5, t: "Sono in menopausa precoce e il mix di sintomi era pesante. Da quando uso il kit gestisco molto meglio le ondate di caldo serali.", n: "Cristina S.", i: "CS", tags: ["vampate", "sonno"] },
    { s: 5, t: "Spiegano benissimo cosa fanno gli ingredienti, solo claim approvati EFSA e D.M. Massima trasparenza, niente promesse magiche.", n: "Lucia G.", i: "LG", tags: ["energia"] },
    { s: 5, t: "Ho confrontato dosaggi con altri brand: qui sono dosaggi seri. La Maca a 300 mg fa la differenza sulla mia energia pomeridiana.", n: "Roberta F.", i: "RF", tags: ["energia"] },
    { s: 4, t: "Compressa al mattino + misurino la sera, routine semplice. La cosa che ho notato di più è il sonno più profondo, anche durante il caldo.", n: "Daniela M.", i: "DM", tags: ["sonno"] },
    { s: 5, t: "Stanchezza pomeridiana era il mio chiodo fisso. Dalla terza settimana di kit ho ricominciato ad arrivare alla sera con energia.", n: "Silvia M.", i: "SM", tags: ["energia"] },
    { s: 5, t: "Le ossa sono la mia preoccupazione, in famiglia abbiamo storia di osteoporosi. La Vitamina D al 200% VNR mi rassicura. Da continuare.", n: "Alessandra F.", i: "AF", tags: ["ossa"] },
    { s: 5, t: "Mi addormento prima e mi sveglio meno volte di notte. Il magnesio bisglicinato si sente, niente effetto lassativo.", n: "Valentina B.", i: "VB", tags: ["sonno"] },
    { s: 4, t: "Provavo altri integratori menopausa senza risultati. Qui dopo un mese ho notato le vampate diminuire in intensità. Riprovo un altro ciclo.", n: "Marina T.", i: "MT", tags: ["vampate"] },
    { s: 5, t: "Lavoro davanti al PC tutto il giorno, stanchezza mentale a picco. Dopo un mese di kit la concentrazione pomeridiana è tornata.", n: "Lorenza R.", i: "LR", tags: ["energia"] },
    { s: 5, t: "Avevo provato altri magnesio ma davano mal di stomaco. Il MAG-5+ no, lo sciogli in acqua e via. Eccellente formulazione.", n: "Francesca L.", i: "FL", tags: ["energia"] },
    { s: 5, t: "Ho dormito profondamente come non capitava da mesi. È diventato il mio rituale serale prima di letto.", n: "Beatrice C.", i: "BC", tags: ["sonno"] },
    { s: 4, t: "Dopo 60 giorni mi sento più centrata. La tensione muscolare nel collo è migliorata, niente più contratture la sera.", n: "Letizia A.", i: "LA", tags: ["ossa", "umore"] }
  ];
  window.KLM_REVIEWS = FALLBACK;
  var THEME_LABELS = { vampate: 'Vampate', sonno: 'Sonno', umore: 'Umore', ossa: 'Ossa', energia: 'Energia' };
  var PER_PAGE = 6, currentPage = 1, filtered = [];
  function starsHtml(n) { var s = ''; for (var i = 0; i < 5; i++) s += i < n ? '★' : '☆'; return s; }
  function renderCard(rev) {
    var tagsHtml = '';
    if (rev.tags && rev.tags.length) {
      tagsHtml = '<div class="klm-review-tags">';
      rev.tags.forEach(function(t) { tagsHtml += '<span class="klm-review-tag">' + (THEME_LABELS[t] || t) + '</span>'; });
      tagsHtml += '</div>';
    }
    var authorHtml = '<div class="klm-review-author"><div class="klm-review-avatar">' + (rev.i || '?') + '</div><div><div class="klm-review-name">' + (rev.n || 'Anonima') + '</div><div class="klm-review-verified">✓ Acquisto verificato</div></div></div>';
    return '<div class="klm-review-card"><div class="klm-review-stars">' + starsHtml(rev.s) + '</div><div class="klm-review-text">' + rev.t + '</div>' + tagsHtml + authorHtml + '</div>';
  }
  function applyFilter(filter) {
    currentPage = 1;
    var reviews = window.KLM_REVIEWS || [];
    filtered = filter === 'all' ? reviews.slice() : reviews.filter(function(r) { return r.tags && r.tags.indexOf(filter) !== -1; });
    renderPage();
  }
  function renderPage() {
    var grid = document.getElementById('klmRevGrid');
    var moreBtn = document.getElementById('klmRevMore');
    var empty = document.getElementById('klmRevEmpty');
    if (!grid) return;
    var end = currentPage * PER_PAGE;
    var visible = filtered.slice(0, end);
    grid.innerHTML = '';
    visible.forEach(function(rev) { grid.innerHTML += renderCard(rev); });
    if (filtered.length === 0) { empty.style.display = 'block'; moreBtn.style.display = 'none'; }
    else { empty.style.display = 'none'; moreBtn.style.display = end < filtered.length ? 'block' : 'none'; }
  }
  window.klmRevLoadMore = function() { currentPage++; renderPage(); };
  document.querySelectorAll('.klm-rev-filter').forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.klm-rev-filter').forEach(function(b) { b.classList.remove('active'); });
      btn.classList.add('active');
      applyFilter(btn.getAttribute('data-filter'));
    });
  });
  applyFilter('all');
})();

/* Value block + guarantee + perks animation observer */
(function() {
  var io = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) {
        e.target.classList.add('klm-vis');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.18 });
  document.querySelectorAll('.klm-value-block, .klm-guarantee, .klm-perks-row').forEach(function(el) { io.observe(el); });
})();
